export default __webpack_public_path__ + "static/media/set_3_360-2.7aa7a97d.svg";